import { TopNav, PageShell, BackCoverFooter, BrutalistBadge } from "@/app/components/brand-scaffold";
import { siteHeaderActions, siteNavItems } from "@/app/content";
import { HomepageProtocolBenefits } from "@/design-system/patterns/homepage-protocol-benefits";
import { HomepageConsoleShowcase } from "@/design-system/patterns/homepage-console-showcase";

export default function VisionPage() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItems} actionItems={siteHeaderActions} homeHref="/" />
      <main className="relative z-10 w-full overflow-hidden">
        <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <div className="mx-auto max-w-5xl">
            <div className="mb-8">
              <BrutalistBadge bgClass="bg-[#8B5CF6]" hoverBgClass="hover:bg-black" hoverTextClass="hover:text-white" className="text-white">
                VISION
              </BrutalistBadge>
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-black mb-4">
              远期愿景
            </h1>
            <p className="text-lg font-bold text-zinc-600 mb-8">
              以下内容是 CALL ANYTHING 的长期方向。它们不是当前已可用的功能。
            </p>
            <div className="border-4 border-black bg-[#FACC15]/20 p-4 mb-12 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
              <p className="text-sm font-bold text-zinc-800">
                ⚠️ 本页内容均为远期规划或概念验证，不代表当前产品状态。如需了解当前可用功能，请查看<a href="/" className="underline font-black">首页</a>。
              </p>
            </div>

            {/* Network Effect Vision */}
            <div className="space-y-8 mb-16">
              <h2 className="text-2xl font-black text-black border-b-4 border-black pb-2">能力网络效应</h2>
              <p className="text-sm text-zinc-700">
                当足够多的 Hotline 上线并被反复调用，网络效应开始形成：Caller 越多，Responder 收益越高；Responder 越多，Caller 可用能力越丰富。这是一个双边市场的经典正循环。
              </p>
              <div className="grid gap-4 sm:grid-cols-3">
                <div className="border-4 border-black bg-white/85 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black text-sm">供给侧</h3>
                  <p className="text-xs text-zinc-600 mt-1">超级个体把经验封装为 Hotline，按调用计费。</p>
                </div>
                <div className="border-4 border-black bg-white/85 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black text-sm">需求侧</h3>
                  <p className="text-xs text-zinc-600 mt-1">Agent 通过 catalog 发现和调用外部能力。</p>
                </div>
                <div className="border-4 border-black bg-white/85 p-4 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]">
                  <h3 className="font-black text-sm">协议层</h3>
                  <p className="text-xs text-zinc-600 mt-1">标准化契约让双边无需相互集成。</p>
                </div>
              </div>
            </div>

            {/* Evolution Path */}
            <div className="space-y-8 mb-16">
              <h2 className="text-2xl font-black text-black border-b-4 border-black pb-2">超级个体演进路径</h2>
              <div className="flex flex-wrap gap-3">
                {evolutionSteps.map((step, idx) => (
                  <div key={step.stage} className="border-4 border-black bg-white/85 p-3 shadow-[3px_3px_0px_0px_rgba(0,0,0,1)]">
                    <span className="text-xs font-black text-zinc-400">Stage {idx + 1}</span>
                    <p className="font-black text-sm">{step.stage}</p>
                    <p className="text-xs text-zinc-600">{step.meta}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reuse existing components */}
        <HomepageProtocolBenefits />
        <HomepageConsoleShowcase />
      </main>
      <BackCoverFooter />
    </PageShell>
  );
}

const evolutionSteps = [
  { stage: "一根 Hotline", meta: "一个人" },
  { stage: "被反复调用", meta: "月活活跃" },
  { stage: "盈利覆盖运维", meta: "盈亏平衡" },
  { stage: "组队升级", meta: "团队 2-3 人" },
  { stage: "公司化稳定服务节点", meta: "公司" },
];
